import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventPage } from './event';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    EventPage,
  ],
  imports: [
		PipesModule,
    IonicPageModule.forChild(EventPage),
  ],
})
export class EventPageModule {}



// WEBPACK FOOTER //
// ./src/pages/event/event.module.ts